import { Navigate, Route, Routes } from 'react-router-dom';
import { PermissionUtils, RoutePaths } from '@shared/utils';
import {
  AccountPage,
  AccountsPage,
  AlertsPage,
  CardPage,
  CardsPage,
  ConciergeOfferPage,
  ConciergePage,
  ConciergeRequestPage,
  DashboardPage,
  ErrorPage,
  IntegrationPage,
  IntegrationsPage,
  IntegrationsCallbackPage,
  MessageCenterPage,
  PaymentBetweenAccountsPage,
  PaymentCardSettlementPage,
  PaymentOtherBankPage,
  PaymentsPage,
  ProfilePage,
  RecipientPage,
  RecipientNewPage,
  ReportsPage,
  RewardsPage,
  StatementsPage,
  TransactionPage,
  UserPage,
  UserManagementPage,
} from '@pages';

export const Private = () => {
  return (
    <Routes>
      {PermissionUtils.viewAlertsPage() && <Route path={RoutePaths.alerts.path} element={<AlertsPage />} />}
      <Route path={RoutePaths.dashboard.path} element={<DashboardPage />} />
      {PermissionUtils.viewAccountsPage() && (
        <>
          <Route path={RoutePaths.accounts.path} element={<AccountsPage />} />
          <Route path={RoutePaths.account.path} element={<AccountPage />} />
        </>
      )}
      {PermissionUtils.viewTransactionPage() && <Route path={RoutePaths.accountTransaction.path} element={<TransactionPage />} />}
      {PermissionUtils.viewPaymentsPage() && (
        <>
          <Route path={RoutePaths.payments.path} element={<PaymentsPage />} />
          <Route path={RoutePaths.paymentsOther.path} element={<PaymentOtherBankPage />} />
          <Route path={RoutePaths.paymentsCard.path} element={<PaymentCardSettlementPage />} />
          <Route path={RoutePaths.paymentsInsignia.path} element={<PaymentBetweenAccountsPage />} />
          <Route path={RoutePaths.paymentsRecipient.path} element={<RecipientPage />} />
          <Route path={RoutePaths.paymentNewRecipients.path} element={<RecipientNewPage />} />{' '}
        </>
      )}
      {PermissionUtils.viewCardsPage() && (
        <>
          <Route path={RoutePaths.cards.path} element={<CardsPage />} />
          <Route path={RoutePaths.card.path} element={<CardPage />} />
        </>
      )}
      {PermissionUtils.viewRewardsPage() && <Route path={RoutePaths.rewards.path} element={<RewardsPage />} />}
      {PermissionUtils.viewConciergePage() && (
        <>
          <Route path={RoutePaths.concierge.path} element={<ConciergePage />} />
          <Route path={RoutePaths.conciergeRequest.path} element={<ConciergeRequestPage />} />
          <Route path={RoutePaths.conciergeOffer.path} element={<ConciergeOfferPage />} />
        </>
      )}
      {PermissionUtils.viewUserManagementPage() && <Route path={RoutePaths.users.path} element={<UserManagementPage />} />}
      {PermissionUtils.viewUserPage() && <Route path={RoutePaths.user.path} element={<UserPage />} />}
      {PermissionUtils.viewStatementsPage() && <Route path={RoutePaths.statements.path} element={<StatementsPage />} />}
      {PermissionUtils.viewReportsPage() && <Route path={RoutePaths.reports.path} element={<ReportsPage />} />}
      <Route path={RoutePaths.callback.path} element={<IntegrationsCallbackPage />} />
      {PermissionUtils.viewIntegrationsPage() && (
        <>
          <Route path={RoutePaths.integrations.path} element={<IntegrationsPage />} />
          <Route path={RoutePaths.integration.path} element={<IntegrationPage />} />
        </>
      )}
      {PermissionUtils.viewMessagesPage() && <Route path={RoutePaths.messages.path} element={<MessageCenterPage />} />}
      {PermissionUtils.viewProfilePage() && <Route path={RoutePaths.profile.path} element={<ProfilePage />} />}
      <Route path={RoutePaths.error.path} element={<ErrorPage />} />
      <Route path={RoutePaths.signup.path} element={<Navigate to={RoutePaths.dashboard.onNavigate()} replace />} />
      <Route path={RoutePaths.success.path} element={<Navigate to={RoutePaths.dashboard.onNavigate()} replace />} />
      <Route path='*' element={<Navigate to={RoutePaths.error.onNavigate()} replace />} />
    </Routes>
  );
};
